import gql from 'graphql-tag';
import { ADDRESS_VIEW_MODEL_FRAGMENT } from 'shared';

export const ACCOUNT_CONTACT_FRAGMENT = gql`
  ${ADDRESS_VIEW_MODEL_FRAGMENT}
  fragment AccountContactFields on AccountContactViewModel {
    id
    email
    phone
    title
    lastName
    firstName

    contactAddress {
      ...AddressFields
    }

    deliveryAddress {
      ...AddressFields
    }
    account {
      id
    }
  }
`;
